import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';

export const listPresetKeys = {
  all: ['list-message-presets'],
};

export const useListPresets = (options = {}) => {
  const { api, UserData, authToken } = useMyContext();

  const { data: presets = [], ...rest } = useQuery({
    queryKey: listPresetKeys.all,
    queryFn: async () => {
      const res = await apiClient.get(
        `${api}list-message-preset/${UserData?.id}`,
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      return res.data?.data ?? [];
    },
    enabled: !!UserData?.id && !!authToken,
    ...options,
  });

  return { presets, ...rest };
};
